import request from '@/router/axios';
let urlPrefix = '/api/shenbao/shenbaocontent'
/**
 * 获取列表
 * @param {Number} page
 * @param {Number} limit
 * @param {Object} params
 */
export const getList = (page, limit, params) => {
    return request(`${urlPrefix}/query`,{
        params: {
            ...params,
            page,
            limit,
        }
    })
}

/**
 * 批量删除
 * @param {Array} ids
 */
export const remove = ids => {
    return request(`${urlPrefix}/deleteBatch`,{
        method: 'delete',
        data: ids
    })
}

/**
 * 获取对象
 * @param {ID} id
 */
export const getEntity = id => {
    return request(`${urlPrefix}/${id}`,)
}


export const getItemEntity = id => {
    return request(`${urlPrefix}/item/${id}`,)
}


/**
 * 添加操作
 * @param {Object} data
 */
export const add = data => {
    return request(`${urlPrefix}`,{
        method: 'post',
        data
    })
}

/**
 * 编辑操作
 * @param {Object} data
 */
export const update = data => {
    return request(`${urlPrefix}`,{
        method: 'put',
        data
    })
}

/**
 * 查重操作
 * @param {Object} params
 */
export const duplicateCheck = params => {
    return request(`${urlPrefix}/duplicateCheck`,{
        method: 'get',
        params
    })
}

/**
 * 上移/下移（排序）
 * @param id
 * @param type
 */
export const getItemSort = (id,type) => {
    return request(`${urlPrefix}/sort/${id}/${type}`,{
        method:'put'
    })
}
